import React, { useState, useEffect } from 'react'
import { DataProvider, NavTabs, PosPage, PosSectionMain } from '../../../components-pos'
import { NavLinks } from '../Index-Setting'

export default function MenuCodesIndex(props) {
  return <DataProvider {...props} Component={Index__} />
}

function Index__(props) {
  // useEffect(() => {
  //   document.body.requestFullscreen()
  // }, [])
  return (
    <PosPage>
      <NavLinks {...props} />
      <NavTabs {...props} size="150px">
        <Comp1 {...props} name="메뉴 그룹" />
        <Comp2 {...props} name="메뉴 아이템" />
      </NavTabs>
    </PosPage>
  )
}

function Comp1(props) {
  // console.log(props)
  return (
    <PosSectionMain>
      <p>메뉴 그룹</p>
    </PosSectionMain>
  )
}

function Comp2(props) {
  return (
    <PosSectionMain>
      <p>메뉴 아이템</p>
    </PosSectionMain>
  )
}
